function custom_more_payments_trigger() {
  const body = document.querySelector('body');
  const custom_more = body.querySelector('#custom_payment_options');
  const custom_more_options = custom_more.querySelector('#custom_payment_options a');
  if (typeof (custom_more_options) != 'undefined') {
    custom_more.classList.remove('hidden');
    custom_more_options.addEventListener("click", function (e) {
      e.preventDefault();
      const more_options = body.querySelector('button.shopify-payment-button__more-options');
      if (typeof (more_options) != 'undefined') {
        more_options.click();
      }
    });
  }
}

window.addEventListener('load', function () {
  const body = document.querySelector('body');
  if (body.classList.contains('template-product')) {
    custom_more_payments_trigger();
  }
});
